export const accordionElement = async (err) => {
  if (err) {
    console.error(err);
  }

  var acc = document.querySelectorAll('.accordion .wp-block-buttons');

  var i;

  for (i = 0; i < acc.length; i++) {
    acc[i].addEventListener('click', function () {
      this.parentElement.classList.toggle('active');
      var panel = this.nextElementSibling;
      if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
      } else {
        panel.style.maxHeight = panel.scrollHeight + 'px';
      }
    });
  }
  /*
   * Infosnow Accordion
   */
  /*   var accInfoSnow = document.querySelectorAll(
    '.accordion__infosnow .wp-block-buttons',
  );
  window.addEventListener('load', function () {
    setTimeout(() => {
      for (i = 0; i < accInfoSnow.length; i++) {
        accInfoSnow[i].parentElement.classList.add('active');
        var panel = accInfoSnow[i].nextElementSibling,
          contHeight = panel.firstElementChild.getBoundingClientRect().height;
        if (panel.style.maxHeight) {
          panel.style.maxHeight = null;
        } else {
          panel.style.maxHeight = contHeight + 'px';
        }
      }
    }, 600);
  }); */
};

import.meta.webpackHot?.accept(accordionElement);
